// extracted by mini-css-extract-plugin
export default {"mode":"SelRewildingMode_mode__P7inM","dots":"SelRewildingMode_dots__qTRpN","dot":"SelRewildingMode_dot__LcPtw","selected":"SelRewildingMode_selected__unzHa"};